/* import __COLOCATED_TEMPLATE__ from './open-list.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();